import { Component, ViewEncapsulation } from '@angular/core';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { AuditTrailService } from 'app/modules/automated-audit-trails/services/automated-audit-trail.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'lodash';
import { ColumnMode } from '@swimlane/ngx-datatable';
import module from "app/modules/automated-audit-trails/automated-audit-trails.module";

@Component({
  selector: 'app-automated-audit-trails',
  templateUrl: './index.page.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: module,
  styleUrls: ['./index.page.scss']
})
export class IndexPage {
  public auditTrailsData$: any = this.auditService.auditTrailData$
  public filterData = {
    pageNumber: 1,
    pageSize: 10,
    wellName: '',
    reportType: '',
    startDate: null,// new Date(),
    endDate: null
  }

  public auditTrailsData = {
    data: [],
    totalPages: 0,
    totalRecords: 0
  }

  public pageSizeList = [
    10,
    20,
    50,
    100
  ]

  dt: any;
  searchForm: UntypedFormGroup;

  constructor(
    private auditService: AuditTrailService,
    private _formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.setDataTable()
    this.getAuditTrails(this.filterData)
    this.auditTrailsData$.subscribe()
  }

  onDateSelected(event: any): void {
    this.filterData.startDate = event.value.toISODate()
    this.getAuditTrails(this.filterData)
  }

  resetDate() {
    this.filterData.startDate = null; // or set it to your initial/default date
    this.getAuditTrails(this.filterData)
  }

  nextPage() {
    this.filterData.pageNumber = this.filterData.pageNumber + 1
    this.getAuditTrails(this.filterData)
  }

  previousPage() {
    this.filterData.pageNumber = this.filterData.pageNumber - 1
    this.getAuditTrails(this.filterData)
  }

  onWellSelectionChange() {
    if (this.filterData.wellName == 'all') {
      this.filterData.wellName = ''
    }

    this.getAuditTrails(this.filterData)
  }

  private getAuditTrails(filterData: any) {
    this.auditService.getData(filterData.pageNumber, filterData.pageSize, filterData.wellName, filterData.startDate).subscribe(res => {
      this.auditTrailsData = res.data
    })
  }

  handleFormatDate(dateString: string, withTime: boolean = true) {
    return handleFormatDate(dateString, withTime)
  }

  setPage(pageInfo) {
    // this.dt.page.offset = pageInfo.offset;
    // this.searchForm.patchValue({
    //     Page: this.dt.page.offset + 1,
    // });
    // // this.service
    // //     .getPreventiveTable(this.searchForm.value)
    // //     .subscribe((pagedData) => {
    // //         this.dt.page.totalPages = pagedData.data.totalPages;
    // //         this.dt.page.totalRecords = pagedData.data.totalRecords;
    // //         this.dt.rows = pagedData.data.data;
    // //     });
  }

  onSort(sort: any) {
    if (!sort.sorts.length) return;
    const { dir, prop } = first<any>(sort.sorts);
    this.searchForm.patchValue({
      OrderBy: prop,
      OrderDir: dir,
    });
    this.setPage({ offset: 0 });
  }

  setDataTable() {
    this.dt = {
      page: {
        size: 5,
        totalRecords: 0,
        totalPages: 0,
        offset: 0,
      },
      column: {
        mode: ColumnMode.flex,
        header: [
          {
            key: 'no',
            name: 'No',
            props: {
              flexGrow: 0.5,
              sortable: false,
              headerClass: ""
            },
          },
          {
            key: 'date',
            name: 'Date',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'platformName',
            name: 'Platform',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'stringShortName',
            name: 'Well Name',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'activity',
            name: 'Activity (PM, CM)',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'result',
            name: 'Result',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: ""
            },
          },
          {
            key: 'remarks',
            name: 'Remarks',
            props: {
              flexGrow: 1,
              sortable: false,
              headerClass: ""
            },
          },

          {
            key: 'act_no',
            name: 'No',
            props: {
              flexGrow: 0.5,
              sortable: false,
              headerClass: "bg-orange"
            },
          },
          {
            key: 'act_start_date',
            name: 'Start Date',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: "bg-orange"
            },
          },
          {
            key: 'act_end_date',
            name: 'End Date',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: "bg-orange"
            },
          },
          {
            key: 'act_platformName',
            name: 'Platform',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: "bg-orange"
            },
          },
          {
            key: 'act_stringShortName',
            name: 'Well Name',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: "bg-orange"
            },
          },
          {
            key: 'act_activity',
            name: 'Activity',
            props: {
              flexGrow: 1,
              sortable: true,
              headerClass: "bg-orange"
            },
          },
          {
            key: 'act_remarks',
            name: 'Remarks',
            props: {
              flexGrow: 1,
              sortable: false,
              headerClass: "bg-orange"
            },
          },
        ],
      },
      rows: [],
    };
  }

  setSearch() {
    this.searchForm = this._formBuilder.group({
        Page: [0],
        PageSize: [5],
        OrderBy: [null],
        OrderDir: [null],
        WellName: [''],
    });
}

  reset() {
    // this.setSearch();
    // this.setPage({ offset: 0 });

    this.filterData.wellName = ''
    this.filterData.startDate = null
    this.getAuditTrails(this.filterData)
  }

  refresh() {
    this.getAuditTrails(this.filterData)
  }
}
